<div style="display: flex; align-items: flex-start; gap: 15px;">
  <button type="button" (click)="openFingerprintCapture()" [value]="this.value" [id]="question.key" class="primary-btn mr-1 ml-1">
    Fingerprint Capture
  </button>
  @if (question?.display_image === true && question.formAction === 'MODIFY' && value != undefined && value != '') {
    <img style="height: 200px; margin-top: -30px;" [src]="'data:image/png;base64,' + previousImage" alt="Fingerprint Image">
  }
</div>